module.exports = __webpack_public_path__ + "img/legal-hero-illustration.61014733.png";